export default (err) => {
    let message = "Ocorreu um erro na sua solicitação";
    let success = err.response?.isSuccess ?? false;
    let status = err.response?.status ?? 500;

    if(status != 200){
        success = false;
        if(status >= 406){
            message = "O sistema passa por instabilidade. Tente novamente em alguns instantes.";
        }
    }else{
        success = true;
        message = "Os dados foram enviados com sucesso";
    }

    if(err?.response?.data !== undefined){
        if(err?.response?.data?.isSuccess !== undefined){
            success = err?.response?.data?.isSuccess;
            message = err?.response?.data?.message ?? message;
        } else if(err?.response?.data?.message){
            message = err?.response?.data?.message;
        }
    }

    return {
        isSuccess: success,
        status,
        message
    };
}